import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { useWatch } from 'react-hook-form'

import { formatRanges, getMomentObjects } from 'helpers/date'
import { notPastDate } from 'helpers/validations'
import { formatErrorMessage } from 'helpers/contactRequestForm'

import FormItem from 'components/Form/Item'
import Tooltip from 'components/Tooltip'
import DatePickerInput from 'components/Form/DatePickerInput'

import './EventDate.less'

const EventDate = (props) => {
  const {
    initialValue,
    onCalendarOpen,
    multiple,
    scrollWhenOpen,
  } = props

  const intl = useIntl()
  const isMobile = useSelector((state) => (state.layout.mobile))
  const [tooltipVisibility, setTooltipVisibility] = useState(false)

  const requestedDates = useWatch({ name: 'requestedDates' })
  const requestedDateRanges = formatRanges(requestedDates, false) || []

  const tooltip = (
    <div className="contact-request-form__event-date__tooltip">
      {requestedDateRanges.map((dateRange, index) => <div key={index}>{dateRange}</div>)}
    </div>
  )

  const onOpenChange = useCallback((status) => {
    onCalendarOpen(status)

    if (!status) {
      setTooltipVisibility(false)
    }
  }, [setTooltipVisibility, onCalendarOpen])

  const eventDateLabel = `contactRequestForm.${multiple ? 'requestedDates' : 'requestedDate'}`
  let initialDate = getMomentObjects(initialValue)

  if (!multiple && initialValue?.[0]) {
    initialDate = moment(initialValue[0])
  }

  return (
    <FormItem
      name="requestedDates"
      label={`${intl.formatMessage({ id: eventDateLabel })}*`}
    >
      <div
        onMouseEnter={() => setTooltipVisibility(true)}
        onMouseLeave={() => setTooltipVisibility(false)}
      >
        <Tooltip
          content={tooltip}
          visible={!isMobile && tooltipVisibility && requestedDateRanges.length > 1}
        >
          <DatePickerInput
            name="requestedDates"
            rules={{
              required: formatErrorMessage(intl, null, 'empty'),
              validate: {
                date: notPastDate(intl.formatMessage({ id: 'projectOffer.form.errors.dateIsInPast' })),
              },
            }}
            defaultValue={initialDate}
            openInLayer={isMobile}
            onOpenChange={onOpenChange}
            multiple={multiple}
            openInPlace={true}
            scrollWhenOpen={scrollWhenOpen}
          />
        </Tooltip>
      </div>
    </FormItem>
  )
}

EventDate.propTypes = {
  layout: PropTypes.object,
  initialValue: PropTypes.array,
  onCalendarOpen: PropTypes.func,
  multiple: PropTypes.bool,
  scrollWhenOpen: PropTypes.bool,
}

EventDate.defaultProps = {
  onCalendarOpen: () => {},
  multiple: true,
  scrollWhenOpen: true,
}

export default EventDate
